jQuery(document).ready(function($){
    $('.accordion__heading').click(function(e) {
        $(this).parent('.accordion__item').toggleClass('open');
    });
});
